import AlertLevel from "../../../models/alert";
import AlertModal from "../../Shared/AlertModal/AlertModal";
import { FormattedMessage } from "react-intl";
import archiveIcon from "../../../assets/buttons/archive.svg";

type ArchiveInfoModalProps = {
  show?: boolean;
  onClose: () => void;
  onArchive: () => void;
  isReviewCompleted?: boolean;
};

const ArchiveInfoModal = ({
  show,
  onClose,
  onArchive,
  isReviewCompleted,
}: ArchiveInfoModalProps) => {
  return (
    <AlertModal
      show={show}
      onClose={onClose}
      level={AlertLevel.Info}
      okBtn={{
        text: (
          <FormattedMessage
            id="ECG_DETAILS.ARCHIVE"
            defaultMessage="YES, ARCHIVE"
          />
        ),
        onClick: onArchive,
        icon: {
          src: archiveIcon,
        },
      }}
      cancelBtn={{
        text: (
          <FormattedMessage
            id="ECG_DETAILS.SINGLE_SAVE.CANCEL_SAVE"
            defaultMessage="BACK TO EDIT"
          />
        ),
        onClick: onClose,
      }}
    >
      <p>
        {isReviewCompleted ? (
          <FormattedMessage
            id="ECG_DETAILS.ARCHIVE.WARNING"
            defaultMessage="Once an ECG is archived, it cannot be de-archived. Are you sure you want to continue?"
            values={{
              br: () => <br></br>,
            }}
          />
        ) : (
          <FormattedMessage
            id="ECG_DETAILS.ARCHIVE.WARNING_UNCOMPLETED"
            defaultMessage="The review on this ECG has not yet been completed. Once an ECG is archived, it cannot be de-archived. Are you sure you want to continue?"
            values={{
              br: () => <br></br>,
            }}
          />
        )}
        <br />
      </p>
    </AlertModal>
  );
};

export default ArchiveInfoModal;
